export default "__VITE_ASSET__da341c9a__"